module.exports = __webpack_public_path__ + "img/Hawaiian_Poke_Chicken.b96c219a.jpg";